import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Catalog from './Catalog';
import TestConsole from './TestConsole';
import ServiceDetail from './ServiceDetail';
import CreateWizard from './CreateWizard';
import { ApiManagerDashboard } from '../api-manager';

export default function ApiManagerPage() {
  return (
    <div>
      <Routes>
        <Route index element={<ApiManagerDashboard />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="test" element={<TestConsole />} />
        <Route path="create" element={<CreateWizard />} />
        <Route path="external" element={<ApiManagerDashboard />} />
        <Route path=":serviceId" element={<ServiceDetail />} />
        <Route path="*" element={<Navigate to="/apis" replace />} />
      </Routes>
    </div>
  );
}